import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";
import {CONSONANT_VOWEL_PAIRS_CH_J} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_chj.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";




export default function CONSONANT_VOWEL_PAIRS_CH_J_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_CH_J} title="Consonant-Vowel Pairs: ㅈ (ch/j)" />
     </>
);}